export default {
  user: {
    icon: require("@/assets/i/white/icon-usuario.svg"),
    iconHover: require("@/assets/i/gray/icon-usuario.svg"),
    titleEs: "Usuarios",
    titleEn: "Users",
    children: [
      {
        titleEs: "Usuarios de centro",
        titleEn: "Location users",
        to: "/administrador/visualizers/locations"
      },
      {
        titleEs: "Agregar nuevo usuario de centro",
        titleEn: "Add new location user",
        to: "/administrador/visualizers/add"
      },
      {
        titleEs: "Agregar nuevo usuario de compañía",
        titleEn: "Add new company user",
        to: "/administrador/visualizers/add_company_user",
        roles: [1]
      },
    ]
  },
  devices: {
    icon: require("@/assets/i/white/icon-dispositivos.svg"),
    iconHover: require("@/assets/i/gray/icon-dispositivos.svg"),
    titleEs: "Dispositivos",
    titleEn: "Devices",
    children: [
      {
        titleEs: "Dispositivos",
        titleEn: "Devices",
        to: "/administrador/devices"
      },
      {
        titleEs: "Agregar nuevo dispositivo",
        titleEn: "Add new device",
        to: "/administrador/devices/add",
        roles: [1]
      }
    ]
  },
  printers: {
    icon: require("@/assets/i/icon-printer-w.svg"),
    iconHover: require("@/assets/i/icon-printer.svg"),
    titleEs: "Impresoras",
    titleEn: "Printers",
    children: [
      {
        titleEs: "Impresoras",
        titleEn: "Printers",
        to: "/printer/all"
      },
      {
        titleEs: "Agregar nueva impresora",
        titleEn: "Add new printer",
        to: "/printer/add",
        roles: [1]
      }
    ]
  },
  centers: {
    icon: require("@/assets/i/white/icon-centros.svg"),
    iconHover: require("@/assets/i/gray/icon-centros.svg"),
    titleEs: "Centros",
    titleEn: "Centers",
    children: [
      {
        titleEs: "Lista de centros de distribución",
        titleEn: "Distribution center list",
        to: "/administrador/locations/"
      },
      {
        titleEs: "Agregar nuevo centro de distribución",
        titleEn: "Add new distribution center",
        to: "/administrador/locations/add",
        roles: [1]
      }
    ]
  }
};
